// extracted by mini-css-extract-plugin
export var cardContainer = "_qn-0";
export var cardHeader = "_qn-2";
export var collapsedState = "_qn-3";
export var dragHandle = "_qn-5";
export var dragHandleIcon = "_qn-6";
export var dragging = "_qn-1";
export var titleArea = "_qn-4";